import { render, staticRenderFns } from "./Telemedicine.vue?vue&type=template&id=2ecc5106&scoped=true"
import script from "./Telemedicine.vue?vue&type=script&lang=js"
export * from "./Telemedicine.vue?vue&type=script&lang=js"
import style0 from "./Telemedicine.vue?vue&type=style&index=0&id=2ecc5106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc5106",
  null
  
)

export default component.exports